import { Observable, throwError } from "rxjs";
import { ScaleStore } from "../../scale.store";

export abstract class SugestaoService {


  protected scaleStore: ScaleStore;
  constructor(scaleStore: ScaleStore) {
    this.scaleStore = scaleStore;
  }

  protected handleError(error: any) {
    return throwError(error);
  }

  protected log(message: string) {
    console.log('============= message response ============');
    console.log(message);
  }

  public abstract sugerirRegraPost(sugestao: String, escalaId: number): Observable<any>;
  public abstract carregaRegrasSugeridasGet(): Observable<any>;
  public abstract carregaRegrasSugeridasByEscalaId(escalaId: number): Observable<any>;

}
